import React from "react";
import { SHELL } from "@/api/connectorPackClient";

// Per spec section F. Adapter coverage by region.
const REGION_ADAPTERS = {
  US: ["Uber", "Uber Health", "Lyft", "Alto", "Wridz"],
  NG: ["Bolt", "GIG Logistics", "Chowdeck", "Mano", "SafeBoda", "City Errand"],
  RW: ["Yego", "Move", "Greenride", "Local moto/taxi partner"],
  GH: ["Uber", "Bolt", "Yango", "GoRide", "GIG Logistics"],
  KE: ["Uber", "Bolt", "Little", "Faras", "Sendy", "Glovo"],
  UG: ["Uber", "Bolt", "SafeBoda", "Tinka", "Little", "Sendy"],
};

export default function MobilityAdapterStatusGrid() {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16, marginTop: 18 }} data-testid="mobility-adapter-grid">
      {Object.entries(REGION_ADAPTERS).map(([region, items]) => (
        <div key={region} style={SHELL.panel}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={{ ...SHELL.h2, color: "#c5a059", textTransform: "none", fontSize: 15 }}>{region}</h3>
            <span style={SHELL.badge()}>{items.length} adapters</span>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 8 }}>
            {items.map((a) => (
              <span key={a} style={SHELL.badge(a.includes("Health") ? "#E5A23A" : "#7AC860")}>{a}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
